import { ICareTeamAssignmentPreview } from '@liquid-state/pephealth-client';

export function formatCareTeamAssignmentPatientLabel(
  assignment: ICareTeamAssignmentPreview,
): string {
  const profile = assignment.patientProfile;
  if (profile) {
    const name = [profile.firstName, profile.lastName]
      .filter(Boolean)
      .join(' ')
      .trim();
    if (name) {
      return name;
    }
  }
  return assignment.appUserId;
}

export function formatCareTeamAssignmentPathwayLabel(
  assignment: ICareTeamAssignmentPreview,
): string | null {
  if (assignment.pathwayName) {
    return assignment.pathwayName;
  }
  if (assignment.pathwayId != null) {
    return String(assignment.pathwayId);
  }
  return null;
}
